import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Careers from './components/Careers.jsx';
import WhyChooseUs from './components/WhyChooseUs';
import MissionVision from './components/MissionVision';
import AboutUs from './components/AboutUs.jsx';
import CoreValues from './components/CoreValues';
import Contact from './components/Contact';
import Footer from './components/Footer';

import CareersPage from './pages/CareersPage';
import AdminLogin from './components/Adminlogin';
import AdminDashboard from './components/AdminDashboard';

import { auth } from './lib/auth';
import './assets/css/App.css';

function App() {
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const keySequenceRef = useRef([]);

  // Check auth status on mount
  useEffect(() => {
    const authenticated = auth.isAuthenticated();
    setIsAdminAuthenticated(authenticated);
  }, []);

  // Secret sequence activation: B + P + D
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if in a form field or already authenticated
      if (
        isAdminAuthenticated ||
        ['INPUT', 'TEXTAREA'].includes(e.target.tagName)
      ) {
        return;
      }

      const key = e.key.toLowerCase();
      keySequenceRef.current.push(key);

      // Keep last 3 keys only
      if (keySequenceRef.current.length > 3) {
        keySequenceRef.current.shift();
      }

      // Check for B + P + D
      if (keySequenceRef.current.join(',') === 'b,p,d') {
        setShowAdminLogin(true);
        keySequenceRef.current = [];
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isAdminAuthenticated]);

  // Handle admin login
  const handleAdminLogin = (adminUser) => {
    setIsAdminAuthenticated(true);
    console.log('Admin logged in:', adminUser);
  };

  // Handle admin logout
  const handleAdminLogout = () => {
    auth.logout();
    setIsAdminAuthenticated(false);
  };

  // If admin is logged in, show dashboard only
  if (isAdminAuthenticated) {
    return <AdminDashboard onLogout={handleAdminLogout} />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <Hero />
                <Services />
                <Careers showJobOpenings={false} />
                <WhyChooseUs />
                <MissionVision />
                <AboutUs />
                <CoreValues />
                <Contact />
                <Footer />
              </>
            }
          />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>

        {/* Admin Login Modal */}
        {showAdminLogin && (
          <AdminLogin
            onClose={() => setShowAdminLogin(false)}
            onLogin={handleAdminLogin}
          />
        )}

        {/* Hidden dev hint */}
        <div className="secret-hint" title="Admin Access: B + P + D" />
      </div>
    </Router>
  );
}

export default App;
